import React from 'react';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMUserResource from 'resources/SMUserResource';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import CSSTransitionGroup from 'react-addons-css-transition-group';

class SMSearchMapRoomView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      room: this.props.room,
      isOpenDefaultFavoriteList: false,
      latestUpdatedFavoriteList: {}
    };
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.room != nextProps.room) {
      this.setState({room : nextProps.room});
    }
  }

  favoriteDidSelect(e) {
    const isFavorite = $(e.currentTarget).hasClass("units-item-fav__on");
    e.preventDefault();
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    const room = this.state.room;
    if (room.is_favorite) {
      // お気に入りに登録されている場合はモーダルを表示させる
      if(this.props.delegate && typeof this.props.delegate.favoriteDidSelect === 'function'){
        this.props.delegate.favoriteDidSelect(this.props.room, isFavorite, "Room");
      }
    } else {
      let responseHandler = (data, error, xhr)=>{
        if (error) {
          room.is_favorite = false;
          this.setState({
            room: room
          });
        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          this.setState({
            room: room,
            latestUpdatedFavoriteList: data.favorite_list,
            isOpenDefaultFavoriteList: true,
          });
          setTimeout(()=>{
            this.setState({
              isOpenDefaultFavoriteList: false,
            });
          }, 2000);
        }
      };
      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);
    }
  }



  render() {
    if (!this.state.room) return null;
    const room = this.state.room;
    const image = SMFormatHelper.roomImageURL(room, {width: 490, height: 490});
    const imageStyle = image ? {} : {background: "#ccc"};
    const directReservationIcon = room.has_direct_reservation_plans ? <i className="fa fa-flash icon-direct"></i> : null;
    let favClassName = room.is_favorite ?
      "units-item-fav__on search-list__map-picup-fav__on" :
      "units-item-fav search-list__map-picup-fav";
    const latestUpdatedFavoriteListPopup = [];
    if (this.state.isOpenDefaultFavoriteList && Object.keys(this.state.latestUpdatedFavoriteList).length !== 0) {
      latestUpdatedFavoriteListPopup.push(
        <div className="search-list__map-favorite-baloon">
          <p className="search-list__map-favorite-text">{this.state.latestUpdatedFavoriteList.name}</p>
        </div>
      );
    }

    return(
      <div className="js-search-list__map-pickup search-list__map-picup clearfix">
        <a style={imageStyle} target="_blank" href={Routes.space_room_path(room.space.username, room.uid, {search_session_id: this.props.searchSessionId})}>
          <img src={image} alt={SMFormatHelper.roomName(room)} className="is-hover fl" />
        </a>
        <div className="search-list__map-picup-inner">
          <h2 className="search-list__map-picup-title link__subcolor"><a target="_blank" href={Routes.space_room_path(room.space.username, room.uid, {search_session_id: this.props.searchSessionId})}>{SMFormatHelper.roomName(room)}</a></h2>
          <p className="search-list__map-picup-price">{room.min_price_text}<span className="units-item__item-per">{SMFormatHelper.priceUnit(room.min_price_unit_text, true)}</span>{directReservationIcon}</p>
          <a onClick={this.favoriteDidSelect.bind(this)} href="#" aria-label="favorit" className={favClassName}><i className="fa fa-heart"></i></a>
          <CSSTransitionGroup transitionName="js-favoritelist-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
            {latestUpdatedFavoriteListPopup}
          </CSSTransitionGroup>
        </div>
      </div>
    );
  }

}

export default SMSearchMapRoomView;



// WEBPACK FOOTER //
// ./app/javascript/components/search/SMSearchMapRoomView.jsx